import { TicketsListView } from '../../AgentTicketsPage';

export default function TeamsQueuePage() {
  return (
    <TicketsListView
      heading="Team Queue"
      subtitle="Current tickets for the team you are assigned to."
      emptyTitle="No current team tickets"
      emptyCopy="All caught up. Check the global queue for new assignments."
      queueScope="team"
    />
  );
}
